import React from 'react';
import styled from '@emotion/styled/macro';
import DatePicker, { registerLocale, ReactDatePickerProps } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldProps } from 'formik';
import './styles.css';

import calendar from 'img/calendar.svg';

registerLocale('ru', ru);

const Input = styled.input({
  display: 'block',
  height: 50,
  width: '100%',
  margin: 0,
  fontSize: 14,
  textAlign: 'left',
  borderRadius: 10,
  border: '1px solid #cbcbcb',
  color: '#708090',
  background: `url(${calendar}) no-repeat`,
  backgroundColor: '#fff',
  backgroundPosition: 'right 20px center',
  backgroundSize: 16,
//@ts-ignore
}, ({hasError}) => ({
  borderColor: hasError ? '#F15642' : 'rgb(203, 203, 203)',
}));

class InputComponent extends React.Component<any> {
  render() {
    const { onClick, value, ...props } = this.props;
    return (
      <Input
        onClick={onClick}
        value={value}
        {...props}
      />
    );
  }
};

type Props = ReactDatePickerProps & {
  hasError?: boolean;
};

const Component: React.FC<Props> = ({ hasError, ...props}) => (
  <DatePicker
    dateFormat="dd.MM.yyyy"
    locale="ru"
    customInput={<InputComponent hasError={!!hasError} />}
    {...props}
  />
);

export const DateField: React.FC<FieldProps> = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => (
  <Component
    {...field}
    onChange={(value) => setFieldValue(field.name, value)}
    selected={field.value}
    hasError={!!errors[field.name]}
    {...props}
  />
);

export default Component;
